const hasCoordinates = (point) => typeof point?.lat === 'number' && typeof point?.lng === 'number';

// buildMapMarkers turns a page of job ads into a pin for every place with
// coordinates. Ads without any such place are counted in unmappedAds.
export const buildMapMarkers = (jobAds = []) => {
  const pins = [];
  let unmappedAds = 0;

  jobAds.forEach((ad) => {
    const places = (ad.places ?? []).filter(hasCoordinates);
    if (places.length === 0) {
      unmappedAds += 1;
      return;
    }
    places.forEach((place) => {
      pins.push({ key: `place-${ad.ad_id}-${place.place_id}`, name: place.name, position: { lat: place.lat, lng: place.lng }, ads: [ad] });
    });
  });

  return { pins, unmappedAds };
};
